import { stats } from "../../mock/mock";

const StatsBar = () => {
  return (
    <section className="py-10 bg-gradient-to-r from-orange-600 via-amber-600 to-orange-600 text-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <p className="font-display font-bold text-3xl md:text-4xl mb-1">{s.number}</p>
              <p className="text-sm md:text-base text-orange-50 font-medium">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsBar;
